/* eslint-disable react-hooks/rules-of-hooks */
import cx from 'classnames'
import React, {
  ComponentType,
  SVGProps,
  useEffect,
  useMemo,
  useState
} from 'react'

import Icon from '@f/elements/Icon'

import { $TSFixMe } from '@f-fertighaus/applications/UserAccount/interfaces/utils'

interface FormSelectProps {
  name?: string | null
  options: $TSFixMe | null
  defaultText?: $TSFixMe | null
  initialValue?: $TSFixMe | null
  reset?: $TSFixMe | null
  className?: $TSFixMe | null
  onChange?: $TSFixMe | null
  inputProps?: $TSFixMe | null
  validation?: $TSFixMe | null
  formElements?: $TSFixMe | null
  setFormElements?: $TSFixMe | null
  placeholder?: $TSFixMe | null
  SelectedOptionIcon?: ComponentType<
    SVGProps<SVGSVGElement> & { value: string }
  >
  [x: string]: $TSFixMe
}

const FormSelect = ({
  name = null,
  options = null,
  defaultText = null,
  initialValue = null,
  reset = null,
  className = null,
  onChange = null,
  inputProps = null,
  validation = null,
  formElements = null,
  setFormElements = null,
  placeholder = null,
  SelectedOptionIcon,
  ...props
}: FormSelectProps) => {
  if (!options) {
    return null
  }

  const [localValue, setLocalValue] = useState(
    initialValue
      ? options.find(
          (option: { value: $TSFixMe }) => option.value === initialValue
        )
      : options.find((option: { isDefault: $TSFixMe }) => option.isDefault)
  )
  const [displayError, setDisplayError] = useState(null)
  const [isValidating, setIsValidating] = useState(false)

  useEffect(() => {
    setLocalValue(
      initialValue
        ? options.find(
            (option: { value: $TSFixMe }) => option.value === initialValue
          )
        : options.find((option: { isDefault: $TSFixMe }) => option.isDefault)
    )
  }, [initialValue, options])

  useEffect(() => {
    if (setFormElements) {
      setFormElements({
        name,
        value: localValue?.value,
        invalidRule: ''
      })
    }

    if (validation) {
      validate(initialValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localValue])

  useEffect(() => {
    if (reset) {
      setLocalValue(
        initialValue
          ? options.find((option: $TSFixMe) => option.value === initialValue)
          : options.find((option: $TSFixMe) => option.isDefault)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset])

  const validate = (value?: $TSFixMe) => {
    const valueToCheck = value ? value : localValue

    validationLoop: for (const validationItem of validation) {
      if (!checkValidation(validationItem, valueToCheck)) break validationLoop
    }
  }

  useEffect(() => {
    if (validation) {
      validate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOption = options.find(
      (option: $TSFixMe) => option.value === event.target.value
    )
    setLocalValue(selectedOption)
    setIsValidating(true)

    event.target.blur()

    if (selectedOption) {
      window._wt({
        category: 'select',
        action: 'change',
        values: [{ type: 'text', value: selectedOption.label }]
      })
    }

    if (onChange) {
      /* This format mimics other input onChange payloads */
      onChange({
        target: {
          name,
          value: selectedOption.value,
          type: 'select',
          selectedOption
        }
      })
    }
  }

  const blurOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.target.blur()
  }

  const checkValidation = (
    validationItem: {
      rule: string
      message: ((prevState: null) => null) | null
    },
    currentValue: { value: string }
  ) => {
    if (validationItem.rule === 'not-empty' && currentValue.value === '') {
      setFormElements({
        name,
        invalidRule: validationItem.rule
      })
      setDisplayError(validationItem.message)
      return false
    }
    setFormElements({
      name,
      value: currentValue.value,
      invalidRule: ''
    })
    setDisplayError(null)
    return true
  }

  const display = useMemo(() => {
    const selectedOption = options.find(
      (option: { value: $TSFixMe; isDefault: $TSFixMe }) =>
        option.value === localValue?.value && !option.isDefault
    )

    return selectedOption
      ? selectedOption.label
      : defaultText ||
          options.find((option: { isDefault: $TSFixMe }) => option.isDefault)
            ?.label
  }, [options, localValue, defaultText])

  let finalClassNames = className + ' f-d-bl'
  if (finalClassNames) {
    let borderClass

    if (
      (formElements && formElements.status === 'validating') ||
      isValidating
    ) {
      if (!/is-validating/.test(finalClassNames)) {
        finalClassNames += ' is-validating'
      }
      if (displayError) {
        borderClass = 'f-c-bo-war'
      } else {
        borderClass = 'f-c-bo-suc400'
      }
    }

    if (borderClass) {
      if (/f-c-bo-/.test(finalClassNames)) {
        finalClassNames = finalClassNames.replace(/f-c-bo-(\w)*/, borderClass)
      } else {
        finalClassNames += ` ${borderClass}`
      }
    }

    if (inputProps && inputProps.readOnly) {
      finalClassNames += ` FormSelect-disabled`
    }
  }

  return (
    <>
      <label
        className={`[ f-overflow ] FormSelect-wrapper ${
          finalClassNames ? finalClassNames : ''
        }`}
        {...props}>
        {SelectedOptionIcon && localValue?.value && (
          <SelectedOptionIcon
            className='FormText-icon'
            value={localValue?.value}
          />
        )}
        <span
          className={cx(
            'FormSelect-display',
            placeholder && 'f-p-t-005',
            localValue && SelectedOptionIcon && 'has-icon'
          )}>
          {display}
        </span>
        {placeholder && (
          <span
            className={cx(
              '[ f-pos-ab f-c-fo-mut f-t-body ] FormTextLabel',
              localValue && 'has-value',
              localValue && SelectedOptionIcon && 'has-icon'
            )}>
            {placeholder}
          </span>
        )}
        <select
          className='FormSelect'
          onInput={blurOnChange}
          onBlur={handleChange}
          value={localValue?.value}
          name={name}
          {...inputProps}>
          {options.map((option: $TSFixMe, index: number) => {
            return (
              <option key={`${index}_${option.value}`} value={option.value}>
                {option.label}
              </option>
            )
          })}
          {!localValue && (
            <option value='' hidden>
              {placeholder}
            </option>
          )}
        </select>
        <Icon
          icon='down-link-16px'
          className='[ f-icon-020 f-c-st-ter ] FormSelect-caret'
        />
      </label>
      {((formElements && formElements.status === 'validating') ||
        isValidating) &&
      displayError ? (
        <span className='[ f-d-bl f-t-mini f-p-a-020 f-c-fo-pri f-c-ba-war f-m-b-020 ] FormError-wrapper'>
          {displayError}
        </span>
      ) : (
        ''
      )}
    </>
  )
}

export default FormSelect
